import { Component, AfterViewInit, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { environment as params } from './../environments/environment';
import { GtmService } from './core/services/utilities/gtm.service';
import { filter } from 'rxjs/operators';
declare let window: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit, OnInit {
  private gaEnable = false;

  constructor(
    private router: Router,
    private _gtm: GtmService,
    private location: Location
  ) {

    this.cssDinamico();
    this.developerMode();
  }

  ngAfterViewInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.cssDinamico();
        this.sendVirtualPage(event);
        const arrRedirectSite = [
          {
            oldUrl: 'categoria_tour/internacionales',
            newUrl: 'https://tours.mundojoven.com/?_ga=2.210022677.1278198282.1580742904-1179417357.1558378078'
          },
          {
            oldUrl: 'categoria_tour/rutas',
            newUrl: 'https://tours.mundojoven.com/ES/theme/1727/ofertas-especiales'
          },
          {
            oldUrl: 'promociones/paquetes-de-viaje',
            newUrl: 'https://mundojoven.com/promociones-paquetes-de-viaje'
          },
          {
            oldUrl: 'promociones-paquetes-de-viaje',
            newUrl: 'https://info.mundojoven.com/outlet-de-viajes'
          },
          {
            oldUrl: 'outlet',
            newUrl: 'https://info.mundojoven.com/outlet-de-viajes?utm_medium=impreso&utm_source=flyer&utm_campaign=outletdeviajes&utm_term=flyer&utm_content=flyer'
          },
          {
            oldUrl: 'categoria_tour/descubre-mexico',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?destination=MDF&geolocalized=Destination%3A%3AMDF'
          },
          {
            oldUrl: 'invierno-en-canada??utm_source=facebook',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?country=CA&geolocalized=Country%3A%3ACA'
          },
          {
            oldUrl: 'categoria_tour/jovenes-18-a-35',
            newUrl: 'https://tours.mundojoven.com/ES/384/jovenes/moreideas?_ga=2.38680227.1432126379.1587745815-1806429730.1584727485&_gac=1.195675672.1586937100.EAIaIQobChMI_pym5fnp6AIVT_DACh0JHAbvEAAYASAAEgJhX_D_BwE'
          },
          {
            oldUrl: 'categoria_tour/rutas',
            newUrl: 'https://tours.mundojoven.com/ES/theme/1727/ofertas-especiales?_ga=2.115179015.1432126379.1587745815-1806429730.1584727485&_gac=1.208989734.1586937100.EAIaIQobChMI_pym5fnp6AIVT_DACh0JHAbvEAAYASAAEgJhX_D_BwE'
          },
          {
            oldUrl: 'destinos_especiales/viajes-a-peru',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?country=PE&geolocalized=Country%3A%3APE'
          },
          {
            oldUrl: 'tours/chiapas-clasico',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?destination=CIP&geolocalized=Destination%3A%3ACIP'
          },
          {
            oldUrl: 'tours/bacalar-y-mahahual-2',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?destination=CHE-2&geolocalized=Destination%3A%3ACHE-2'
          },
          {
            oldUrl: 'tours/huasteca-potosina-extrema',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?destination=SLP&geolocalized=Destination%3A%3ASLP'
          },
          {
            oldUrl: 'conservación-de-elefantes-en-tailandia',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?country=TH&geolocalized=Country%3A%3ATH'
          },
          {
            oldUrl: 'tours/auroras-boreales-2',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?country=CA&geolocalized=Country%3A%3ACA'
          },
          {
            oldUrl: 'destinos_especiales/viajes-a-italia',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?country=IT&geolocalized=Country%3A%3AIT'
          },
          {
            oldUrl: 'invierno-en-canada?sr_source=verizon&sr_lift=true&sr_campaign=ipg',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?country=CA&geolocalized=Country%3A%3ACA'
          },
          {
            oldUrl: 'categoria_tour/rutas/#utm_source=google&utm_medium=pagado&utm_campaign=brand_term&utm_term=mundo_joven',
            newUrl: 'https://tours.mundojoven.com/ES/theme/1727/ofertas-especiales?_ga=2.147723191.1432126379.1587745815-1806429730.1584727485&_gac=1.171699732.1586937100.EAIaIQobChMI_pym5fnp6AIVT_DACh0JHAbvEAAYASAAEgJhX_D_BwE'
          },
          {
            oldUrl: 'tours/europe-express',
            newUrl: 'https://tours.mundojoven.com/ES/79/europa/moreideas'
          },
          {
            oldUrl: 'bolsa-de-trabajo',
            newUrl: 'https://mundojoven.com/bolsa-de-trabajo/?_ga=2.38565539.1432126379.1587745815-1806429730.1584727485&_gac=1.6565382.1586937100.EAIaIQobChMI_pym5fnp6AIVT_DACh0JHAbvEAAYASAAEgJhX_D_BwE'
          },
          {
            oldUrl: 'tours/verano-peru-2020/#utm_source=facebook&utm_medium=organico&utm_campaign=rutas&utm_term=mundo_joven&utm_content=verano-peru',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?country=PE&geolocalized=Country%3A%3APE'
          },
          {
            oldUrl: 'tours/semana-santa-barrancas-del-cobre-los-mochis-chihuahua',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?destination=LMM&geolocalized=Destination%3A%3ALMM'
          },
          {
            oldUrl: 'ofertas/vuelos-baratos-a-nueva-york',
            newUrl: 'https://mundojoven.com/ofertas/vuelos-baratos-a-nueva-york'
          },
          {
            oldUrl: 'tours/wester-spirit',
            newUrl: 'https://tours.mundojoven.com/ES/79/europa/moreideas'
          },
          {
            oldUrl: 'ofertas/vuelos-baratos-a-londres',
            newUrl: 'https://mundojoven.com/ofertas/vuelos-baratos-a-londres'
          },
          {
            oldUrl: 'tours/norwegian-spirit-mediterraneo-e-islas-griegas/#utm_source=facebook&utm_medium=organico&utm_campaign=crucero&utm_term=mundo_joven&utm_content=norwegian',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?country=GR&geolocalized=Country%3A%3AGR'
          },
          {
            oldUrl: 'tours/turquia-2019',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?country=TR&geolocalized=Country%3A%3ATR'
          },
          {
            oldUrl: 'tours/magia-en-cuatrocienegas',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?destination=fake-811&geolocalized=Destination%3A%3Afake-811'
          },
          {
            oldUrl: 'tours/chepe-de-chihuahua-a-los-mochis',
            newUrl: 'https://tours.mundojoven.com/ES/holidays/search?destination=LMM&geolocalized=Destination%3A%3ALMM'
          }
        ];
        const _path = this.router.url;
        const location = window.location;
        arrRedirectSite.map(({oldUrl, newUrl}) => {
          if (_path.includes(oldUrl)) {
            window.location.href = newUrl;
          }
        });
      }
    });
  }


  ngOnInit() {

    // this.location.path()

    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd)
      )
      .subscribe((navEnd: NavigationEnd) => {
      });

  }

  sendVirtualPage(event) {
    this._gtm.sendVirtualPage(event);
  }

  cssDinamico() {
    if (this.router.url.includes('seguros')) {
    } else {
      this.addCss(
        params.production
          ? params.api.mj + 'wp-content/themes/MundoJoven2019/dist/assets/scss/append.css'
          : 'wp-content/themes/MundoJoven2019/dist/assets/scss/append.css'
      );
    }
  }

  addCss(ref) {
    let file = location.pathname.split('/').pop();
    let link = document.createElement('link');
    link.href = file.substr(0, file.lastIndexOf('.')) + ref;
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.media = 'screen,print';
    document.getElementsByTagName('head')[0].appendChild(link);
  }

  /**
   * @description Oculta todos los console.log por default, se deben activar manualmente (Solamente en productivo)
   */
  developerMode() {
    var _log = console.log;
    window._logDev = console.log;
    window.enableDev = function () {
      window.console.log = function (logMessage) {
        window._logDev.apply(console, arguments);
      };
    };

    window.console.log = function (logMessage) {
      if (!(<any>params).production) {
        _log.apply(console, arguments);
      }
    };
  }
}
